import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/diphoterineInfo.css";

export function DiphoterineInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllDiphoterineBurnfreeById(id, config).then(
                    (res) => {
                        setData(res);
                    }
                );
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    return (
        <div>
            <div className="container-dipho-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Diphoterine e Burnfree</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container">
                            <div className="table-content">
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Área</th>
                                            <th>Quantidade MINI DAP</th>
                                            <th>Quantidade DAP 5 litros</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{check.ds_area ? check.ds_area : "Não informado"}</td>
                                        <td>{check.ds_mini_dap ? check.ds_mini_dap : "Não informado"}</td>
                                        <td>{check.ds_dap_cinco_l ? check.ds_dap_cinco_l : "Não informado"}</td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Quantidade lava olho</th>
                                            <th>Quantidade Burfree</th>
                                            <th>Data da inspeção</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{check.ds_lava_olhos ? check.ds_lava_olhos : "Não informado"}</td>
                                        <td>{check.ds_burnfree ? check.ds_burnfree : "Não informado"}</td>
                                        <td>{check.dt_inspecao ? formatDate(check.dt_inspecao) : "Não informado"}</td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
